import {
  TextInput, Grid, Paper,
} from '@mantine/core';
import { Page } from '@/components';
import PropTypes from 'prop-types';
import FirstBorrowerIcon from '@/assets/images/firstBorrower.svg?react'; // eslint-disable-line import/no-unresolved
import SecondBorrowerIcon from '@/assets/images/secondBorrower.svg?react'; // eslint-disable-line import/no-unresolved
import ThirdBorrowerIcon from '@/assets/images/thirdBorrower.svg?react'; // eslint-disable-line import/no-unresolved

const BorrowerDetailsSection = ({ index, form, classes }) => {
  const isPrimary = index === 0;
  // eslint-disable-next-line no-nested-ternary
  let title = index === 1 ? 'לווה משני' : index === 2 ? ' לווה שלישי ' : 'לווה ראשי';
  title = `${title} - ${form?.values?.borrowers?.[index]?.fullName}`;

  const borrowerIcons = [FirstBorrowerIcon, SecondBorrowerIcon, ThirdBorrowerIcon];
  const BorrowerIcon = borrowerIcons[index] || FirstBorrowerIcon;

  return (
    <Paper >
      <Page.Section
        withBackground={false}
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <BorrowerIcon style={{ width: '30px', height: '30px' }} />
            <span>{title}</span>
          </div>
        }
      >
        <div className={classes.formContainer}>
          <Grid className={classes.formGrid} style={{ width: '100%' }}>
            {!isPrimary && (
              <>
                <Grid.Col span={3}>
                  <TextInput
                    label="מספר ת.ז"
                    required
                    {...form.getInputProps(`borrowers.${index}.idNumber`)}
                  />
                </Grid.Col>
                <Grid.Col span={3}>
                  <TextInput
                    label="שם הלווה"
                    required
                    {...form.getInputProps(`borrowers.${index}.fullName`)}
                  />
                </Grid.Col>

                <Grid.Col span={3}>
                  <TextInput
                    label="מספר טלפון"
                    required
                    maxLength={10}
                    {...form.getInputProps(`borrowers.${index}.phoneNumber`)}
                  />
                </Grid.Col>

                <Grid.Col span={3}>
                  <TextInput
                    label="כתובת אימייל"
                    required
                    {...form.getInputProps(`borrowers.${index}.email`)}
                  />
                </Grid.Col>
              </>
            )}

            <Grid.Col span={3}>
              <TextInput
                label="עיר מגורים"
                required
                {...form.getInputProps(`borrowers.${index}.city`)}
              />
            </Grid.Col>

            <Grid.Col span={3}>
              <TextInput
                label="שם רחוב ומספר"
                required
                {...form.getInputProps(`borrowers.${index}.address`)}
              />
            </Grid.Col>
          </Grid>
        </div>
      </Page.Section>
    </Paper>
  );
};

BorrowerDetailsSection.propTypes = {
  index: PropTypes.number.isRequired,
  form: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default BorrowerDetailsSection;
